import { TripDesign } from './types';

export const parlorScreen: TripDesign = {
  id: 'parlor-screen',
  name: 'The Parlor',
  description: 'Amethyst and gold — warm, dramatic, celebratory',
  category: 'custom',
  tags: ['elegant', 'nightlife', 'formal'],
  tokens: {
    bgPrimary: '#130E1C',
    bgSurface: '#1B1427',
    bgElevated: '#231B30',
    textPrimary: '#EDE4D8',
    textSecondary: '#938EA4',
    textTertiary: '#5A4E70',
    accent: '#C8923A',
    border: 'rgba(200,146,58,0.10)',
    borderEmphasis: 'rgba(200,146,58,0.40)',
    ornament: 'rgba(200,146,58,0.40)',
    ornamentLine: 'rgba(200,146,58,0.25)',
    success: '#2A9068',
    warning: '#C4A44A',
    error: '#9C3555',
    confirmed: '#2A9068',
    negative: '#9C3555',
  },
  typography: {
    displayFont: 'Bodoni Moda',
    displayFontUrl: 'https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,400;0,6..96,600;0,6..96,700;0,6..96,800;0,6..96,900;1,6..96,400;1,6..96,500;1,6..96,600&display=swap',
    fontSize: {
      // Scannable content — grounded in Apple HIG / Material / Airbnb benchmarks
      itemName: '17px',      // Apple Body/Headline 17pt — primary scannable content
      dayHeader: '14px',     // Airbnb dividers / Material subhead — navigation landmarks
      bodyDetail: '14px',    // Material body 14sp — functional secondary text
      body: '15px',          // Apple Subheadline 15pt — general body text
      detail: '12px',        // Apple Caption 1 12pt — tertiary metadata only
      sectionHeader: '11px', // Apple Caption 2 11pt — uppercase letter-spaced labels
      metaLabel: '11px',     // Apple Caption 2 11pt — chips / badges
      button: '11px',        // Apple Caption 2 11pt — CTA text
      timestamp: '13px',     // Apple Footnote 13pt — time / date pills
      // Stable display roles
      tripTitle: '34px',
      screenHeader: '24px',
      subtitle: '15px',
      wordmark: '8px',
      bodyLarge: '16px',
      bodyInput: '14px',
      displaySmall: '18px',
    },
  },
  options: {
    ornamentStyle: 'diamond-cluster',
    progressDotShape: 'diamond',
    buttonAccentFlanking: true,
    cardBorderRadius: 2,
    headerLayout: 'centered-formal',
    elevationStyle: 'tonal',
    chipStyle: 'subtle-fill',
  },
};
